<p-dialog
  (onHide)="hideLearnAboutMeDialog()"
  [visible]="showLearnAboutMeDialog"
  (visibleChange)="onFlag('showLearnAboutMeDialog', $event)"
  [blockScroll]="true"
  [dismissableMask]="true"
  [draggable]="false"
  [modal]="true"
  [baseZIndex]="4000"
  maskStyleClass="learn-about-me-dialog-mask"
  styleClass="learn-about-me-dialog"
  appendTo="body"
  [style]="{
    width: !isMobile ? '840px' : '90%',
    maxHeight: '90vh',
    padding: '0 10px 10px'
  }">
  <div class="header flex justify-content-between align-items-center">
    <div class="left-column text-sm">
      <div class="name-and-position font-bold">
        <span class="name">{{ currentPitchCard.name }}</span>
        <span class="comma">, </span>
        <span class="position">{{ currentPitchCard.title }}</span>
      </div>
      <div class="business-name">{{ currentPitchCard?.businessName }}</div>
      <div class="location">
        {{ currentPitchCard?.cityTbl?.cityName + ', ' || '' }}
        {{ currentPitchCard?.stateTbl?.stateName + ', ' || '' }}
        {{ currentPitchCard?.country?.name }}
      </div>
    </div>
    <div class="contact-wrapper relative">
      <button
        class="contact-button w-10rem p-3 test-sm button outline rounded-border pointer"
        (click)="toggleContactMenu($event, contactMenuParent)"
        translate
        [style.color]="
          getTextColor(currentPitchCard?.primaryPitchColor) === '#000000'
            ? '#000000'
            : currentPitchCard?.primaryPitchColor
        "
        [style.border]="'1px solid ' + currentPitchCard.primaryPitchColor">
        Contact Options
      </button>
      <div class="contact-menu-container modal z-1" #contactMenuParent>
        <div
          class="contact-menu"
          (mouseenter)="mouseEnterContactMenu()"
          (mouseleave)="mouseLeaveContactMenu()">
          <ng-template #contactMenu>
            <ul>
              <li
                *ngIf="
                  currentPitchCard?.contactNumber &&
                  !currentPitchCard?.isHideContactNumber
                ">
                <span class="flex pl-4">
                  <img
                    alt="call-outline"
                    class="contact-menu-icon"
                    src="/assets/images/pitch-card-svg/contact-menu/icon-phone.svg" />
                </span>
                <a (click)="addCallsAnalytics()">
                  <span class="cm-title pr-1">Call</span>
                  <span class="cm-value">{{
                    currentPitchCard?.contactNumber
                      | phone: currentPitchCard?.contactNumber
                  }}</span>
                </a>
              </li>

              <li
                *ngIf="
                  currentPitchCard?.textingNumber &&
                  !currentPitchCard?.isHideTextNumber
                ">
                <span class="flex pl-4">
                  <img
                    alt="call-outline"
                    class="contact-menu-icon"
                    src="/assets/images/pitch-card-svg/contact-menu/icon-message.svg" />
                </span>
                <a (click)="addTextAnalytics()">
                  <span class="cm-title pr-1">Text</span>
                  <span class="cm-value">{{
                    currentPitchCard?.textingNumber
                      | phone: currentPitchCard?.textingNumber
                  }}</span>
                </a>
              </li>

              <li
                *ngIf="
                  currentPitchCard?.email && !currentPitchCard?.isHideEmail
                ">
                <span class="flex pl-4">
                  <img
                    alt="email-outline"
                    class="contact-menu-icon"
                    src="/assets/images/pitch-card-svg/contact-menu/icon-mail.svg" />
                </span>
                <a
                  (click)="addEmailAnalytics()"
                  class="text-ellipsis relative m-auto">
                  <span class="cm-title">Email</span>
                  <span class="cm-value">{{ currentPitchCard?.email }}</span>
                </a>
              </li>
              <li *ngIf="currentPitchCard?.websiteLink">
                <span class="flex pl-4">
                  <img
                    alt="email-outline"
                    class="contact-menu-icon"
                    src="/assets/images/pitch-card-svg/contact-menu/icon-globe.svg" />
                </span>
                <a
                  [href]="
                    currentPitchCard.websiteLink.includes('http')
                      ? currentPitchCard.websiteLink
                      : 'https://' + currentPitchCard.websiteLink
                  "
                  target="_blank"
                  class="text-ellipsis relative m-auto">
                  <span class="cm-title">Visit Website</span>
                  <span class="cm-value">{{
                    currentPitchCard?.websiteLink
                  }}</span>
                </a>
              </li>
              <li
                *ngIf="
                  currentPitchCard?.address &&
                  currentPitchCard?.city !== AppSettings.DEFAULT_CITY_ID &&
                  currentPitchCard?.state !== AppSettings.DEFAULT_STATE_ID &&
                  !currentPitchCard?.isHideAddress
                ">
                <span class="flex pl-4">
                  <img
                    alt="direction-pin"
                    class="contact-menu-icon"
                    src="/assets/images/pitch-card-svg/contact-menu/icon-directions.svg" />
                </span>
                <a
                  (click)="addLocationAnalytics()"
                  [attr.href]="googleMapLink"
                  target="_blank">
                  <span class="cm-title">Directions</span>
                </a>
              </li>
              <li (click)="onTitleClick('contact')">
                <div class="flex align-items-center w-full">
                  <span class="flex pl-4">
                    <img
                      alt="referral-outline"
                      class="contact-menu-icon"
                      src="/assets/images/pitch-card-svg/contact-menu/icon-contact.svg" />
                  </span>
                  <span class="cm-title w-full">Contact Me</span>
                </div>
              </li>
              <li
                *ngIf="currentPitchCard?.calendarLink"
                (click)="showCalendar(currentPitchCard?.calendarLink)">
                <div class="flex align-items-center w-full">
                  <span class="flex pl-4">
                    <img
                      class="contact-menu-icon"
                      src="/assets/images/pitch-card-svg/contact-menu/icon-calendar.svg" />
                  </span>
                  <span class="cm-title w-full">Schedule</span>
                </div>
              </li>
              <li
                (click)="onTitleClick('leaveareview')"
                *ngIf="currentPitchCard?.videoReviewCount === 0">
                <span class="flex pl-4">
                  <img
                    alt="review-outline"
                    class="contact-menu-icon"
                    src="/assets/images/pitch-card-svg/review-outline.svg" />
                </span>
                <span class="cm-title full-width"
                  >Leave a Video Testimonial</span
                >
              </li>
            </ul>
          </ng-template>

          <ng-template [ngTemplateOutlet]="contactMenu"></ng-template>
        </div>
      </div>
    </div>
  </div>

  <!-- <div class="business-hours" *ngIf="false">
    <button
      type="button"
      class="hours-tile"
      (click)="toggleBusinessHoursDropdown()"
      [attr.aria-expanded]="isBusinessListOpened"
    >
      <span
        class="status"
        [class.closed]="!isBusinessOpenNow"
        [class.open]="isBusinessOpenNow"
      >
        {{ isBusinessOpenNow ? 'Open' : 'Closed' }}
      </span>
      <span class="next-change">{{ businessHoursNextChangeText }}</span>
      <span class="chevron" [class.opened]="isBusinessListOpened"></span>
    </button>

    <div class="business-hours-list" *ngIf="isBusinessListOpened">
      <div class="hours-item" *ngFor="let day of businessHoursList">
        <span class="day">{{ day.day }}</span>
        <span class="time" [class.closed]="day.isClosed">
          <ng-container *ngIf="day.isClosed; else openHours">
            Closed
          </ng-container>
          <ng-template #openHours>
            <span class="time-range" *ngFor="let range of day.ranges">
              {{ range }}
            </span>
          </ng-template>
        </span>
      </div>
    </div>
  </div> -->

  <div
    class="elevator-text text-base border-round-xl p-3 my-5 white-space-pre-line"
    [innerHTML]="currentPitchCard?.writtenElevatorPitchScript"></div>
  <div class="links flex gap-2 mb-5">
    <a
      class="website-link-element h-6rem w-6rem flex flex-column justify-content-between align-items-center border-round-xl no-underline py-3"
      [href]="
        currentPitchCard.websiteLink.includes('http')
          ? currentPitchCard.websiteLink
          : 'https://' + currentPitchCard.websiteLink
      "
      target="_blank"
      *ngIf="currentPitchCard.websiteLink">
      <img
        class="logo max-w-2rem max-h-2rem"
        src="assets/images/new-pitch-card-icons/website-icon.svg" />
      <span class="text text-center">
        {{ currentPitchCard.websiteLinkCallToAction || 'Visit Website' }}
      </span>
    </a>
    <a
      class="calendar-link-element h-6rem w-6rem flex flex-column justify-content-between align-items-center border-round-xl no-underline py-3"
      [href]="
        currentPitchCard.calendarLink.includes('http')
          ? currentPitchCard.calendarLink
          : 'https://' + currentPitchCard.calendarLink
      "
      target="_blank"
      *ngIf="currentPitchCard.calendarLink">
      <img
        class="logo max-w-2rem max-h-2rem"
        src="assets/images/new-pitch-card-icons/calendar-icon.svg" />
      <span class="text text-center">
        {{ currentPitchCard.calendarLinkCallToAction || 'Calendar' }}
      </span>
    </a>
    <div class="link-element flex gap-2" *ngIf="currentPitchCard.links?.length">
      <a
        *ngFor="let link of currentPitchCard.links"
        [href]="link.link.includes('http') ? link.link : 'https://' + link.link"
        target="_blank"
        class="other-link-element h-6rem w-6rem flex flex-column justify-content-between align-items-center border-round-xl no-underline py-3 overflow-hidden">
        <img
          class="logo max-w-2rem max-h-2rem"
          [src]="
            'https://www.google.com/s2/favicons?domain=' + link.link + '&sz=256'
          " />
        <span
          class="text text-center pl-2 pr-2 overflow-hidden full-width text-ellipsis"
          >{{ link.callToAction || link.link }}</span
        >
      </a>
    </div>
  </div>
  <div class="d-grid" *ngIf="currentPitchCard.organizationPartners?.length">
    <div class="gallery-header text-base font-semibold mb-3">
      Member ({{ currentPitchCard.organizationPartners?.length || 0 }})
    </div>
    <div class="inline-flex overflow-x-auto mb-2">
      <ng-container
        *ngFor="let partnerItem of currentPitchCard?.organizationPartners">
        <div
          *ngIf="partnerItem?.logo"
          class="partner-item flex align-items-center mr-2 p-1">
          <img
            class="relative overflow-hidden border-round-lg"
            [src]="partnerItem?.logo"
            [width]="70 * scaleFactor"
            alt="" />
        </div>
      </ng-container>
    </div>
  </div>
  <div
    class="video-testimonials-header flex justify-content-between align-items-center">
    <div class="header-text text-base font-semibold">
      <span
        class="header-name"
        *ngIf="currentPitchCard.businessType === 'resume'">
        Video References
      </span>
      <span
        class="header-name"
        *ngIf="currentPitchCard.businessType !== 'resume'">
        Video Testimonials
      </span>
      <span class="header-counter">
        ({{ learnAboutMeReviews.length || 0 }})
      </span>
    </div>
    <a
      *ngIf="!currentPitchCard?.isOwner"
      class="add-testimonial"
      (click)="videoFileInput.click()">
      <input
        id="user-testimonials-upload"
        #videoFileInput
        class="opacity-0 pointer-events-none absolute"
        (change)="videoFileChangeEvent($event)"
        type="file"
        name="video-testimonail upload"
        accept="video/*" />
      +
      {{
        currentPitchCard === 'resume'
          ? 'label_add_reference'
          : ('label_add_testimonial' | translate)
      }}
    </a>
  </div>
  <div class="video-testimonials my-3 flex gap-2 overflow-x-auto">
    <ng-container *ngFor="let reviewItem of learnAboutMeReviews; let i = index">
      <div class="relative">
        <div
          class="relative video-item-container overflow-hidden p-0 cursor-pointer"
          (click)="playVideo.emit(reviewItem.videoReviewUrl)">
          <img
            class="video-thumbnail relative overflow-hidden w-auto border-round-lg"
            [src]="reviewItem.videoReviewThumbnailUrl"
            alt="" />
          <img
            class="absolute btn-play top-50 left-50 border-circle flex align-items-center justify-content-center"
            height="42"
            src="assets/images/tile-images/icon-play-btn.svg"
            alt=""
            width="42" />
        </div>
      </div>
    </ng-container>
    <div
      *ngIf="!learnAboutMeReviews?.length"
      class="relative video-item-container overflow-hidden p-0 flex justify-content-center align-items-center p-3 max-w-9rem text-xs">
      <span class="text-center">
        Be the first to leave a video
        {{ currentPitchCard === 'resume' ? 'reference' : 'testimonial' }}!
      </span>
    </div>
  </div>
  <div
    class="gallery-header text-base font-semibold"
    *ngIf="currentPitchCard?.employeePictureThumnailUrl?.length > 0">
    Gallery ({{ currentPitchCard?.employeePictureThumnailUrl?.length || 0 }})
  </div>
  <div
    class="gallery-thumbnails flex align-items-center gap-2 my-2 relative overflow-x-auto"
    *ngIf="currentPitchCard?.employeePictureThumnailUrl?.length > 0">
    <ng-container
      *ngFor="
        let galleryItem of currentPitchCard?.employeePictureThumnailUrl;
        let i = index
      ">
      <div class="relative" (click)="openGallery(i, true)">
        <div class="relative gallery-image-item-container cursor-pointer">
          <img
            *ngIf="!isDocument(galleryItem)"
            [src]="getFilePreviewSrc(galleryItem)"
            alt=""
            style="height: 100%; width: 100%; object-fit: cover" />
          <ngx-doc-viewer
            *ngIf="isDocument(galleryItem)"
            [url]="galleryItem"
            [googleCheckContentLoaded]="true"
            [googleCheckInterval]="3000"
            style="
              object-fit: contain;
              display: block;
              width: 100%;
              height: 75vh;
            "
            viewerUrl="https://docs.google.com/gview?url=%URL%&embedded=true"></ngx-doc-viewer>
        </div>
      </div>
    </ng-container>
  </div>
  <div class="bio-header text-base font-semibold">Bio/More Info</div>
  <div class="bio-text" [innerHTML]="currentPitchCard.pricingModel"></div>
</p-dialog>
